import React from "react";

import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import WPPaginaDAO from "./dataAccess/WP/WPPaginaDAO";
import Carregando from "./components/Carregando";
import Rodape from "./components/Rodape";

type AjudaPagPolBQProps = {};

type AjudaPagPolBQState = {
  carregando: boolean;
  titulo: string;
  conteudo: string;
  concluido: boolean;
};

class AjudaPagPolBQ extends React.Component<
  AjudaPagPolBQProps,
  AjudaPagPolBQState
> {
  constructor(props: AjudaPagPolBQProps) {
    super(props);

    this.state = {
      carregando: false,
      concluido: false,
      titulo: "",
      conteudo: "",
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Ajuda / Pagina / Política bem querer");

    this.setState({ carregando: true });

    WPPaginaDAO.getInstance()
      .getPolPrivBQ()
      .then((privacidade: any) => {
        this.setState({
          titulo: privacidade[0].titulo,
          conteudo: privacidade[0].conteudo,
          carregando: false,
          concluido: true,
        });
      });
  }

  render(): any {
    const { carregando, titulo, conteudo, concluido } = this.state;

    return (
      <section className="help">
        <div className="header">
          <BotaoVoltar titulo={titulo}></BotaoVoltar>
        </div>
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: conteudo }}
        ></div>
        <Rodape parent={this} ativo="Menu"></Rodape>
        <Carregando exibir={carregando} concluido={concluido} />
      </section>
    );
  }
}

export default AjudaPagPolBQ;
